import { render } from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=template&id=eca44e94&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOfficialGazette.vue?vue&type=style&index=0&id=eca44e94&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca44e94"]])

export default __exports__